import { Box, Drawer } from '@mui/material';
import LayoutItems from '../Layout/LayoutItems';
import Profile from '../AccountMenu';
import { SidebarProps } from './types';
import { X } from 'phosphor-react';

export const Sidebar = ({
  header,
  mobileHeader,
  sidebarItems,
  user,
  dropdownItems,
  isDrawerOpen,
  closeDrawer,
}: SidebarProps) => {
  const SidebarComponent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          padding: '32px 24px',
          flexDirection: 'column',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            '@media(min-width: 768px)': {
              height: '100%',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
              '-ms-overflow-style': 'none',
              '::-webkit-scrollbar': {
                display: 'none',
              },
            },
          }}
        >
          {sidebarItems.map((item, index) => (
            <LayoutItems
              key={index}
              item={item}
              selected={item.selected}
              onClick={item.onClick}
            />
          ))}
        </Box>
        {!!user && <Profile user={user} dropdownItems={dropdownItems} />}
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          borderRight: '1px solid #DBE0E2',
          '@media(max-width: 768px)': {
            display: 'none',
          },
        }}
      >
        {header}
        <SidebarComponent />
      </Box>
      <Drawer
        open={!!isDrawerOpen}
        sx={{
          display: 'none',
          '@media (max-width: 768px)': {
            display: 'block',
          },
        }}
        anchor='left'
        PaperProps={{
          style: {
            width: '100%',
            overflowX: 'hidden',
          },
        }}
      >
        {mobileHeader || header}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            paddingTop: '15px',
            paddingRight: '15px',
          }}
          onClick={() => closeDrawer && closeDrawer(false)}
        >
          <X size={32} />
        </Box>
        <SidebarComponent />
      </Drawer>
    </>
  );
};
